import { render, staticRenderFns } from "./ExtraDocument.vue?vue&type=template&id=272f9494&"
import script from "./ExtraDocument.vue?vue&type=script&lang=js&"
export * from "./ExtraDocument.vue?vue&type=script&lang=js&"
import style0 from "./ExtraDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports